import type { OutgoingEmail } from '~/shared/types/outgoingEmail'

/**
 * An outbox email's status, from the Trigger Email extension's
 * `delivery.state` and our own cancel marker.
 *
 * The extension writes the state in capitals (PENDING, PROCESSING, RETRY,
 * SUCCESS, ERROR; functions/index.js queries `'ERROR'`). The old mapping
 * matched `'error'` and `'processing'` in lower case, so every failed email
 * showed as pending and couldn't be sent again from the Emails page.
 * Cancelling only sets `metadata.cancelled`; an email the extension hasn't
 * picked up yet then shows as cancelled.
 */
export function emailStatusFromMailDoc(
  deliveryState: string | undefined,
  cancelled = false,
): OutgoingEmail['status'] {
  switch (deliveryState?.toUpperCase()) {
    case 'SUCCESS': return 'SUCCESS'
    case 'ERROR': return 'ERROR'
    case 'PROCESSING':
    case 'RETRY': return 'sending'
    default: return cancelled ? 'cancelled' : 'pending'
  }
}
